import block from 'bem-cn';
import React from 'react';
import Button from '../Button/Button';
import InputField from '../InputField/InputField';
import './SignUpForm.scss';

const b = block('SignUpForm');

const SignUpForm = () => {
  return (
    <form className={b()}>
      <div className={b('wrapper')}>
        <h2 className={b('caption')}>Регистрация</h2>
        <ul className={b('inputs')}>
          <li className={b('email')}>
            <InputField type={'email'} placeholder={'E-mail'} />
          </li>
          <li className={b('password')}>
            <InputField type={'password'} placeholder={'Пароль'} /></li>
        </ul>
        <Button width100 text='Подтвердить' />
      </div>
    </form>
  );
}

export default SignUpForm;